<template>
    <div class="banner-image-area position-relative section-space--ptb_90">
        <div class="container_fl">
            <div class="row align-items-center">
                <div class="col-lg-6 order-1 order-lg-1 wow move-up">
                    <div class="banner-image__media">
                        <img src="../assets/img/celestin/lost.png" class="img-fluid" alt="">
                    </div>
                </div>
                <div class="col-lg-6 order-2 order-lg-2 wow move-up">
                    <div class="banner-image__content">
                        <div class="section-title-wrapper mb-20">
                            <h2 class="section-title font-weight--light">{{ $t('title') }}</h2>
                        </div>
                        <ul class="check-list green-check-list section-space--mb_50 wow move-up">
                            <li class="list-item">{{ $t('li1') }}</li>
                            <li class="list-item">{{ $t('li2') }}</li>
                            <li class="list-item">{{ $t('li3') }}</li>
                            <li class="list-item">{{ $t('li4') }}</li>
                        <div class="banner-image__text section-space--mb_40">
                        {{ $t('goal') }}
                        </div>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-space--pt_90">
            <div class="vc_row-separator big_triangle_alt bottom">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 100 100" fill="#054452">
                    <polygon points="0,0 50,100 100,0 101,100 0 101"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'BannerOne',
    };
</script>

<i18n>
{
  "en": {
    "title": "Managing IBS is hard",
    "li1": "IBS is painful, confusing",
    "li2": "Oftentimes dismissed by the medical community",
    "li3": "No cure",
    "li4": "A lot of options : probiotics, diet...",
    "goal": "Dyjest’s goal is to make that experience easy and clear for you so you can resolve your symptoms as quickly as possible."
  },
  "fr": {
    "title": "Gérer le SII est difficile.",
    "li1": "Le SII est douloureux, déroutant",
    "li2": "Souvent ignoré par la communauté médicale",
    "li3": "Pas de traitement",
    "li4": "Beaucoup d'options : probiotiques, régime...",
    "goal": "L'objectif de Dyjest est de rendre cette expérience aussi facile et claire que possible, pour vous permettre de réduire vos symptômes aussi rapidement que possible."
  }
}
</i18n>